import React, { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import LoaderContainer from "../mui/LoaderContainer";
import ErrorBoundary from "../mui/error_boundary/ErrorBoundary";
import HeaderContainer from "../home/header/HeaderContainer";
import ChatTabStream from "./ChatTabStream";
import { ENUM_ELEMENT_NAME } from "../common/enums";
import MobileTipsPlug from "./window/controls/mobile_tips/mobile_tips_plug/MobileTipsPlug";
import PrivatModalContainer from "./PrivatModalContainer";

const Footer = lazy(() => import("../home/Footer"));
const UnderChat = lazy(() => import("../chat/chat/UnderChat"));

export default function CurrentModelContent() {
  const { t } = useTranslation();

  const broadcasterId = useSelector((state) => state.chat.broadcaster.id);
  const broadcasterChatId = useSelector((state) => state.chat.broadcaster?.chat?.id);
  const broadcasterOnline = useSelector((state) => state.chat.broadcaster?.online);

  return (
    <>
      <LoaderContainer loading={broadcasterOnline ? !broadcasterChatId : !broadcasterId}>
        <main className={`chat ${t("currentLang")}`} name={ENUM_ELEMENT_NAME.streamMain}>
          <ErrorBoundary>
            <HeaderContainer />
          </ErrorBoundary>
          <ErrorBoundary>
            <ChatTabStream />
          </ErrorBoundary>
          <ErrorBoundary>
            <Suspense>
              <UnderChat />
            </Suspense>
          </ErrorBoundary>
          <ErrorBoundary>
            <Suspense>
              <Footer />
            </Suspense>
          </ErrorBoundary>
          <MobileTipsPlug />
        </main>
      </LoaderContainer>

      <PrivatModalContainer />
    </>
  );
}
